import { React } from 'react';

import "./index.scss";

const SkeletonLoader = ({type="container", width=100, height=100, count=4, currentPage="dashboard"}) => {

    return (
        <>
            {currentPage === "dashboard" && <div className="skeleton-container" style={{width:`${width}%`, height:`${height}%`}}>
                {type === "circle" && <div className="circle"></div>}
                {type === "line" &&
                    Array.from({ length: count }).map((_, index) => (
                    <div className="line" key={index}></div>
                ))}
                {type === "container" && <div className="rect"></div>}
            </div>}
            {currentPage !== "dashboard" && <div className="skeleton-container status-loading" style={{width:`${width}%`, height:`${height}%`}}>
                {type === "circle" && <div className="circle"></div>}
                {type === "line" &&
                    Array.from({ length: count }).map((_, index) => (
                    <div className="line" key={index}></div>
                ))}
                {type === "container" && <div className="rect"></div>}
            </div>}
        </>
    )
}

export default SkeletonLoader;